/**
 * @owner @Appboy/whats-app
 */

import { z } from "zod";
import { common } from "../common";
import { kakaoMessageDetailsSchema } from "../shared/kakaoMessageDetailsSchema";
import { messageGetBaseSchema } from "./messageGetBaseSchema";

export const kakaoMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("kakao"),
  link_template_ids: z.array(z.union([z.string(), common.objectId])).nullable(),
  messages: z.array(kakaoMessageDetailsSchema).optional(),
  // null until a KakaoTalk channel is selected (MessageVariation#as_json always emits ms_id)
  messaging_service_id: z.union([z.string(), common.objectId]).nullable().optional(),
  click_tracking_enabled: z.boolean().nullable().optional(),
});
